import React, { useEffect, useState } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getServices } from "../../../../api/serviceApi";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateServiceDialog from "./UpdateServiceDialog";

const ServicesTable = ({ theme }) => {
  const navigate = useNavigate();
  const [openUpdateService, setOpenUpdateService] = useState(false);
  const [rows, setRows] = useState([]);
  const [currentService, setCurrentService] = useState({});

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    const response = await getServices();

    setRows([...response]);
  };

  const handleOpenUpdateService = (event, params) => {
    event.stopPropagation();
    setCurrentService(params.row);
    setOpenUpdateService(true);
  };

  const handleCloseUpdateService = () => {
    setOpenUpdateService(false);
  };

  const handleRowClick = (params) => {
    navigate(`service/${params.row.id}`, { state: params.row });
  };

  const columns = [
    { field: "name", headerName: "Service", flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
    { field: "imageUrl", headerName: "Image URL", flex: 1 },
    { field: "sequence", headerName: "Sequence", flex: 1 },

    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      flex: 1,
      renderCell: (params) => {
        return [
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faPen} />}
            label="Update"
            onClick={(e) => {
              handleOpenUpdateService(e, params);
            }}
          />,
        ];
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Services</StyledH2>
      <UpdateServiceDialog
        openUpdateService={openUpdateService}
        handleCloseUpdateService={handleCloseUpdateService}
        currentService={currentService}
        fetchServices={fetchServices}
      />
      <StyledDataGrid
        onRowClick={handleRowClick}
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default ServicesTable;
